<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JaJkhK/Images/TimeTrapSeries_covers.jpg?1697126297428" alt="This image is the cover for the book Pieces of Eight, Time Trap"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pieces of Eight, Time Trap
      </h1>
      <p class="bookDescription body article font2">
        <b>A swashbuckling pirate adventure in the time travel series from the “masterful” national bestselling author of the Pearls and the Crown novels (<i>Extrapolations</i>).</b><br/>  <br/> In his attempt to return to the twenty-sixth century, historian and time traveler Noel Kedran is transported back to the Caribbean in 1697, where black-masted ships rule the treacherous seas and murderous pirates kill without mercy.<br/>  <br/> Stalked by enemies—including his evil twin, Leon—Noel fights to prevent a human sacrifice that could change history, and to stop his twisted twin before he destroys them both for a few glittering, golden pieces of eight.<br/>  <br/> “Chester is a world class fantasist.” —<i>The Best Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Chester
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21ab8024